<script lang="ts">
  import { getAppearance } from './appearance.svelte';
  import { DEFAULT_ICONS, type IconName } from './registry';
  interface Props {
    name: IconName;
    monochrome?: boolean;
  }
  let { name, monochrome = false }: Props = $props();
  const appearance = getAppearance();
  let failed = $state(false);
  const icon = $derived(appearance.theme.icons[name]);
  // A new icon source gets a fresh chance to load.
  $effect(() => {
    void icon;
    failed = false;
  });
</script>

<span
  class="theme-icon"
  class:monochrome={monochrome && 'src' in icon && !failed}
  style:--icon-mask={monochrome && 'src' in icon && !failed ? `url("${icon.src}")` : undefined}
  aria-hidden="true"
>
  {#if 'src' in icon && !failed}
    <img src={icon.src} alt="" draggable="false" onerror={() => (failed = true)} />
  {:else}
    {'text' in icon ? icon.text : DEFAULT_ICONS[name]}
  {/if}
</span>

<style>
  .theme-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1em;
    height: 1em;
    vertical-align: -0.12em;
    flex-shrink: 0;
    pointer-events: none;
  }
  .monochrome {
    background: currentColor;
    -webkit-mask: var(--icon-mask) center / contain no-repeat;
    mask: var(--icon-mask) center / contain no-repeat;
  }
  .monochrome img {
    opacity: 0;
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
